module.exports = __webpack_public_path__ + "img/iran.7952053f.svg";